import TranslationItemModel from "@models/translationItemModel";
import { IDrag } from "../interface";

export class DragLiModel implements IDrag {
  constructor(data?: Partial<DragLiModel>) {
    if (data) Object.assign(this, data);
  }
  Id: string | number;
  Image?: string;
  Translate?: Array<TranslationItemModel>;
  SortIndex: number;
}
